<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17fM6kD/tc-custom/9781480438637.jpg?1705547605579" alt="This image is the cover for the book City of Truth"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">City of Truth
      </h1>
      <p class="bookDescription body article font2">
        <b>This “delightful” Nebula Award–winning novella about a world without lies has “a sharp, unmerciful edge that would have pleased old Jonathan Swift” (<i>Minneapolis Star-Tribune</i>).</b><br/>  Truth reigns supreme in the city-state of Veritas. Not even politicians lie, and weirdly frank notices abound—such as warning: this elevator maintained by people who hate their jobs: ride at your own risk. In this dystopia of mandatory candor, every preadolescent citizen is ruthlessly conditioned, through a Skinnerian ordeal called a “brainburn,” to speak truthfully under all circumstances.<br/> Jack Sperry wouldn’t dream of questioning the norms of Veritas; he’s happy with his life and his respectable job as a “deconstructionist,” destroying “mendacious” works of art—relics from a less honest era. But when his adored son, Toby, falls gravely ill, the truth becomes Jack’s greatest enemy. Somehow our hero must overcome his brainburn and attempt to heal his child with beautiful lies.<br/> Alternately hilarious and moving, <i>City of Truth</i> thoughtfully explores the pitfalls inherent in any attempt to engineer a perfect society.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Morrow
      </h2>
      
      <p class="authorDescription body article">Born in 1947, James Morrow has been writing fiction ever since he, as a seven-year-old living in the Philadelphia suburbs, dictated &ldquo;The Story of the Dog Family&rdquo; to his mother, who dutifully typed it up and bound the pages with yarn. This three-page, six-chapter fantasy is still in the author&rsquo;s private archives. Upon reaching adulthood, Jim produced nine novels of speculative fiction, including the critically acclaimed Godhead Trilogy. He has won the World Fantasy Award (for <i>Only Begotten Daughter</i> and <i>Towing Jehovah</i>), the Nebula Award (for &ldquo;Bible Stories for Adults, No. 17: The Deluge&rdquo; and the novella <i>City of Truth</i>), and the Theodore Sturgeon Memorial Award (for the novella <i>Shambling Towards Hiroshima</i>). A fulltime fiction writer, Jim makes his home in State College, Pennsylvania, with his wife, his son, an enigmatic sheepdog, and a loopy beagle. He is hard at work on a novel about Darwinism and its discontents.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1a6f41f1